<template>
  
  <div class="overlay-height-container position-relative" :class="{ overlayMode: displayMode == 'overlay' }">
    <DeleteConfirmation  :deleteMethod="deletionConfirmed" :used_info_list="used_info_list" />
    <FileDescription
      :show="modalShown"
      :file="openedFile"
      v-on:modal_closed="(payload) => modalClosed(payload)"
    />
    <FileInfo
      :show="infoShown"
      :file="openedFile"
      v-on:modal_closed="infoClosed"
    />
    <Loader v-if="loading" />

    <div id="flash-message" class="alert alert-warning mediaLibraryAlert" role="alert"></div>

    <div class="pull-right margin-b-30" v-if="displayType != 'ckeditor' && displayMode != 'overlay'">
      <label class="hide-on-small">
        {{ trans("lms.Thumbnail") }}
        <input
          type="radio"
          name="view-type"
          :checked="this.displayType == 'thumbnail'"
          value="thumbnail"
        />
      </label>
      <span style="margin: 5px"></span>
      <label class="hide-on-small">
        {{ trans("lms.Table") }}
        <input
          type="radio"
          name="view-type"
          :checked="this.displayType == 'table'"
          value="table"
        />
      </label>
    </div>
    <input
          type="text"
          id="searchInput"
          :placeholder="trans('lms.Search')"
          class="form-control search-upload "
           @keyup="searchItems()"
        />
    <Filters v-if="showFilter" :tags="allTags" :displayMode="displayMode" :filterFrontend="filterFrontend"/>
    
    <div id="file-manager" style="position: relative" :class="{fullHeight : fileUpload=='true' && displayMode=='overlay', borderRadius: allTags.length &&  displayMode == 'overlay'}">

      <div v-if="this.allow_adding_url == 'true'">
        <span data-toggle="modal" data-target="#addMediaUrlModal">
           <i style="cursor: pointer; position: absolute; bottom: 15px; right: 15px" class="add-url-button fa fa-plus fa-lg" aria-hidden="true"
             title="Add URL from media pool"></i>
        </span>
      </div>


      <div v-if="displayMode == 'overlay'" class="pull-right hide-on-small" style="margin:5px">
        <label class="hide-on-small">
          {{ trans("lms.Thumbnail") }}
          <input
            type="radio"
            @click="changeDisplayType('thumbnail')"
            v-model="displayType"
            :checked="displayType == 'thumbnail'"
            value="thumbnail"
          />
        </label>
        <span style="margin: 5px"></span>
        <label class="hide-on-small">
          {{ trans("lms.Table") }}
          <input
            type="radio"
            @click="changeDisplayType('table')"
            v-model="displayType"
            :checked="displayType == 'table'"
            value="table"
          />
        </label>
      </div>

      <ul class="files-wraper" v-bind:class="{ tableBlock: displayType == 'table' }" style="width: 100%">
          <!-- table view -->
          <table v-if="displayType=='table'" class="table table-table">
            <thead>
              <tr class="column-active">
                <th class="sortable asc" @click="sort('name')">
                  {{ trans("lms.filename") }}:
                </th>
                <th class="sortable" @click="sort('mime_type')">
                  {{ trans("lms.Icon") }}:
                </th>
                <th class="sortable" @click="sort('updated_at')">
                  {{ trans("lms.Uploaded") }}:
                </th>
                <th class="sortable" @click="sort('author')">
                  {{ trans("lms.Author") }}:
                </th>
                <th class="sortable" @click="sort('size')">
                  {{ trans("lms.Size") }}:
                </th>
                <th class="sortable" @click="sort('description')">{{ trans("lms.Description") }}:</th>
                <th>{{ trans("lms.Action") }}:</th>
              </tr>
            </thead>
            <tbody>
              <MediaItem v-for="file in files" :key="file.id" :file="file" :document_preview_disabled="document_preview_disabled" :show="hide" :prevent_preview="document_preview_disabled" :displayType="displayType" :isAdmin="isAdmin || file.custom_properties.uploader == user_id" :isFrontend="isFrontend" :seen="usedFilesIds.includes(file.id)" :showModal="showModal" :showInfo="showInfo"/>
            </tbody>
          </table>
          <!-- thumbnail view -->
          <template v-else>
            <MediaItem v-for="file in files" :key="file.id" :file="file" :document_preview_disabled="document_preview_disabled" :show="hide" :prevent_preview="document_preview_disabled" :displayType="displayType" :isAdmin="isAdmin || file.custom_properties.uploader == user_id" :isFrontend="isFrontend" :seen="usedFilesIds.includes(file.id)" :showModal="showModal" :showInfo="showInfo"/>
          </template>
      </ul>
    </div>

    <template v-if="fileUpload != 'true'">
      <div id="dropzone-wrap" class="dropzone-wrap" v-show="showDropzone">
        <span class="fileupload-process">
          <div
            id="total-progress"
            class="progress progress-striped active"
            role="progressbar"
            aria-valuemin="0"
            aria-valuemax="100"
            aria-valuenow="0"
          >
            <div
              class="progress-bar progress-bar-info"
              data-dz-uploadprogress
            ></div>
          </div>
        </span>

        <form action :id="dropzone_id" class="courseDropzone">
          <div id="dropzone-placeholder" class="dz-message">
            
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-upload" viewBox="0 0 16 16">
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"/>
              </svg>
            
            {{ trans("lms.DropFilesMessage") }}
          </div>
        </form>
      </div>
    </template>
  </div>

</template>

<script>
  import Bus from "../bus";
  import Dropzone from "../dropzone";
  import BootstrapVue from "bootstrap-vue";
  import FileDescription from "./filedescription";
  import FileInfo from "./fileinfo";
  import Loader from "./loader";
  import MediaItem from "./media_item";
  import StatisticsButton from "./statisticsbutton";
  import DeleteConfirmation from "./deleteconfirmation";
  import Filters from "./filters";
  Vue.use(BootstrapVue);

  export default {
    props: ["main_color", "view", "mode", "prevent_preview", "allow_adding_url", "file_upload", "masterdata" , "show_filter", "deletable_and_editable", 'meeting_id', 'direct_media_type', 'chunk_size','show'],

    components: {
      FileDescription,
      FileInfo,
      Loader,
      StatisticsButton,
      DeleteConfirmation,
      MediaItem,
      Filters
    },
    data() {
      return {
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
        dropzone_id: null,
        modalShown: false,
        infoShown: false,
        openedFile: {},
        currentSort: "name",
        currentSortDir: "asc",
        allTags: [],
        files: [],
        usedFilesIds: [],
        searchedFiles: [],
        type: null,
        clientID: localStorage.getItem("clientID"),
        isAdmin: false,
        showDropzone: false,
        certificates: false,
        showFilter: true,
        isFrontend: false,
        displayType: this.view,
        displayMode: this.mode,
        document_preview_disabled: this.prevent_preview,
        fileUpload: this.file_upload,
        user_id: "",
        hide: this.show,
        filterFrontend: false,
        currentUrl: null,
        getClientUri: "/media/getclientid",
        getDropzoneUri: "/media/addmedia",
        getDropzoneCompleteUri: "/media/allmedia",
        getAllOnLoadUri: "/media/allmedia",
        loading: true,
        restrict_message_recipients: false,
        dropFilesMessage: this.trans('lms.DropFilesMessage'),
        message: '',
        id_to_delete: null,
        used_info_list: [],
        media_type: localStorage.getItem('media_type'),
        media_id: localStorage.getItem('media_id')
      };
    },
    created() {
     
      this.dropzone_id =
        "courseDropzone_" + localStorage.getItem("media_id")
      this.currentUrl = window.location.href;
      this.restrict_message_recipients = this.checkIfMessagingIsRestricted();
    },
    methods: {
      checkIfMessagingIsRestricted: function () {
        if (!this.masterdata) {
          return true;
        }
        try{
          let masterdata = JSON.parse(this.masterdata);
          if(masterdata.restrict_message_recipients == 0){ // if masterdata restrict_message_recipients is 0, messaging is not restricted
            return false;
          }
        }catch(e){
        
        }
      },
      modalClosed(payload) {   
        let wrapper = document.getElementById('modal-back');
        if(wrapper){
          document.body.removeChild(wrapper);
        }
        let file = this.files.find(file => file.id == payload.file_id);
        if(file){
          let formatedTags = payload.tags.map(tag => {
            if(tag.hasOwnProperty('text')){
              return tag;
            }
            return {
              text: tag
            };
          });
          file.name = payload.name;
          file.tags =  formatedTags;
          file.info.description = payload.description;
          file.info.multiclient = payload.multiclient;
        }
        this.modalShown = !this.modalShown;
        this.openedFile = {}; 
        this.getTags();
     
        
      },
      showModal(file) {
        this.modalShown = !this.modalShown;
        this.openedFile = file;
         let wrapper = document.createElement('div');
        wrapper.id="modal-back"
        document.body.appendChild(wrapper);
        wrapper.style="position:absolute;z-index:5;background-color:black;opacity:.8;width:100%;height:150%;top:0px;left:0px;"
      },
      showInfo(file) {
        this.infoShown = !this.infoShown;
        this.openedFile = file;
         let wrapper = document.createElement('div');
        wrapper.id="modal-back"
        document.body.appendChild(wrapper);
        wrapper.style="position:absolute;z-index:5;background-color:black;opacity:.8;width:100%;height:150%;top:0px;left:0px;"
      },
      infoClosed() {
        this.infoShown = !this.infoShown;
        this.openedFile = {};
        let wrapper = document.getElementById('modal-back');
        document.body.removeChild(wrapper);
      },
      sort(s) {
      //if s == current sort, reverse
        if (s === this.currentSort) {
          this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
        }
        this.currentSort = s;
        this.sortItems();
      },
      searchItems(){

        if (this.displayType === 'table') {

          let items = document.getElementsByClassName('drag-li');
          let searchInput = document.getElementById('searchInput').value;

          for (let i = 0; i < items.length; i++) {
            let element = items[i];
            let match = element.textContent.toLowerCase().indexOf(searchInput.toLowerCase()) > -1;
            
            if (match) {
                element.style.display = "";
            } else {
                element.style.display = "none";
            }
          }

        } else {

          let items = document.getElementsByClassName('item-li');
          let searchInput = document.getElementById('searchInput').value;

          for (let i = 0; i < items.length; i++) {
              let element = items[i];  
              let match = element.id.toLowerCase().indexOf(searchInput.toLowerCase()) > -1;

              if (match) {
                element.style.display = "";
              } else {
                element.style.display = "none";
              }
          }

        }
      },
      sortItems() {
        if (typeof this.files !== "undefined") {
          return this.files.sort((a, b) => {
            let modifier = 1;
            if (this.currentSortDir === "desc") modifier = -1;
            if(this.currentSort == 'description' || this.currentSort == 'author' || this.currentSort == 'updated_at'){
              if ((typeof a.info[this.currentSort] == 'string' ? a.info[this.currentSort].toLowerCase() : a.info[this.currentSort]) < (typeof b.info[this.currentSort] == 'string' ? b.info[this.currentSort].toLowerCase() : b.info[this.currentSort])) return -1 * modifier;
              if ((typeof a.info[this.currentSort] == 'string' ? a.info[this.currentSort].toLowerCase() : a.info[this.currentSort]) > (typeof b.info[this.currentSort] == 'string' ? b.info[this.currentSort].toLowerCase() : b.info[this.currentSort])) return 1 * modifier;
            }
            if ((typeof a[this.currentSort] == 'string' ? a[this.currentSort].toLowerCase() : a[this.currentSort]) < (typeof b[this.currentSort] == 'string' ? b[this.currentSort].toLowerCase() : b[this.currentSort])) return -1 * modifier;
            if ((typeof a[this.currentSort] == 'string' ? a[this.currentSort].toLowerCase() : a[this.currentSort]) > (typeof b[this.currentSort] == 'string' ? b[this.currentSort].toLowerCase() : b[this.currentSort])) return 1 * modifier;
            return 0;
          });
        }
      },
      getUrlParam(paramName) {
        var reParam = new RegExp("(?:[?&]|&)" + paramName + "=([^&]+)", "i");
        var match = window.location.search.match(reParam);

        return match && match.length > 1 ? match[1] : null;
      },
      getUsedFiles() {
        axios.get("/media/usedmedia").then((response) => {
          this.usedFilesIds = response.data;
        });
      },
      deletionConfirmed(){
          
        let id = this.id_to_delete;
        axios.delete("/media/" + id, {
              user_id: this.user_id,
              _token: this.csrf,
            })
            .then(response => {
              let id = response.data.id;
              this.files = this.files.filter(item => {
                let tempId = item.delete_id ? item.delete_id : item.id;
                return tempId != id;
              });
              window.notification('success', response.data.message);
              $('#fileDeleteModal').modal("hide");
            })
            .catch((error) => {
              window.notification('warning', error.message);
              $('#fileDeleteModal').modal("hide");
            });
            let wrapper = document.getElementById('modal-back');
          document.body.removeChild(wrapper);
      },
      changeDisplayType(displayType) {
        axios.post("/media/change/display", {
          display_type: displayType,
          _token: this.csrf,
        }).then(function( response ){
          if(typeof pageFiles == "function"){
            pageFiles();
          }
        })
      },
      uniqueTags(){
        if (this.allTags !== undefined){
          const distinctTags = [...new Map(this.allTags.map(item =>[item['text'], item])).values()];
          this.allTags = distinctTags;
        }
        else {
          this.allTags = [];
        }
      },
      getClientInfo(){
        axios.get(this.getClientUri).then((response) => {
          this.clientID = response.data["client_id"];
          this.isAdmin = response.data["admin"];
          this.user_id = response.data["user_id"];
        });
      },
      checkDropzone(typeid, type){
          this.media_type = type;
          this.media_id = typeid;
          axios.post("/admin/media/check/dropzone", {
            id: typeid,
            type: type,
            _token: this.csrf,
          })
          .then((response) => {
            this.showDropzone = response.data["allow"];
          });
      },
      getData(id = false, type = false) {
        let data = {
          id:
            localStorage.getItem("media_id") != null
              ? localStorage.getItem("media_id") : null,
          type:
            localStorage.getItem("media_type") != null
              ? localStorage.getItem("media_type")
              : "all",
          meeting_id: this.meeting_id,
          _token: this.csrf,
        }
        if(id){
          data.id = id;
        }
        if(this.direct_media_type != null){
          data.type = this.direct_media_type
        }
        if(type){
          data.type = type;
        }
        if(data.id == ''){
          delete data.id;
        }
        if (data.meeting_id == 0) {
          delete data.meeting_id;
        }
        this.loading = true;
        axios.post(this.getAllOnLoadUri, data)
          .then((response) => {
            this.files = response.data.files;
            this.loading = false;
          });
      },
      configureDropzone(){
        let allowedMimeTypes = document.querySelector('meta[name="mime-types"]').attributes.content.nodeValue;
        if (this.fileUpload !== "true") {
          if (this.fileUpload !== undefined) {
            this.showDropzone = true;
          }
          let self = this;
          let myDropzone_id = "#" + this.dropzone_id;
          let myDropzone = new Dropzone(myDropzone_id, {
            url: self.getDropzoneUri,
            chunking: true,
            forceChunking: true,
            chunkSize: parseInt(self.chunk_size) * 1000 || 1000000,
            parallelChunkUploads: false,
            parallelUploads: 1,
            retryChunks: true,
            retryChunksLimit: 3,
            createImageThumbnails: false,
            preview: false,
            previewTemplate: '<div style="display:none"></div>',
            sending: function(file, xhr, formData) {
              formData.append("id", self.media_id);
              formData.append("type", self.media_type);
              formData.append("meeting_id", self.meeting_id);
              formData.append("_token", self.csrf);
              sessionStorage.setItem('file_size',file.size);
            },
            success: function(data) {
              if (data.xhr !== undefined && data.xhr.response !== undefined) {
                let response = JSON.parse(data.xhr.response);
                let message = response.points_message;
                if (typeof window.getTree === "function") {
                  window.getTree(window.getTreeRoute);
                }
                if (message !== undefined && message !== null && message.length > 0) {
                    window.notification('success', message);
                    let numberPattern = /\d+/g;
                    let stringNumbers = message.match(numberPattern);
                    if (stringNumbers.length > 0 && self.isFrontend) {
                      window.updatePoints(stringNumbers[0]);
                    }
                  }
              }
            },
            paramName: "file", // The name that will be used to transfer the file
            maxFilesize: 1024, // MB
            acceptedFiles: allowedMimeTypes,
            timeout: 300000,
            init: function() {
              this.on("error", function(file, message) {
                message = typeof message === "object" && undefined !== message.message ? message.message : message;
                window.notification('danger', message);
              });
            },
            dictInvalidFileType: "Unsupported file type",
          });
          
          myDropzone.autoDiscover = false;

          myDropzone.on("complete", (file) => {
            this.getData(this.media_id, this.media_type);
            if (self.files) {
              sessionStorage.setItem("id", localStorage.getItem("media_id"));
              sessionStorage.setItem("has_documents", true);
            }
            let dropFilesMessage = self.dropFilesMessage;
            $('#courseDropzone').html('<div id="dropzone-placeholder" class="dz-message">' + dropFilesMessage  + '</div>');
          });

          myDropzone.on("totaluploadprogress", function(progress,file,bytesSent) {
            let totalFileSize = parseInt(sessionStorage.getItem('file_size'));
            progress =(bytesSent / totalFileSize) * 100;
            document.querySelector("#total-progress .progress-bar").style.width = progress + "%";
          });
                
          myDropzone.on("sending", function (file) {
            document.querySelector("#total-progress").style.display = "block";
          });
                
          myDropzone.on("queuecomplete", function (progress) {
            document.querySelector("#total-progress").style.display = "none";
            document.querySelector("#total-progress .progress-bar").style.width = "0%";
          });
        }
      },
      initiate(){
        if (window.location.href.indexOf("certificate") > -1) {
          this.certificates = true;
        }
        if (window.innerWidth <= 650) {
          this.displayType = "thumbnail";
        }
        this.currentUrl = window.location.href;
        if (document.querySelector("#app") && document.querySelector("#app").classList.contains("backend-wrapper")) {
          this.showFilter = true;
        }

        if (this.currentUrl.indexOf("/files") > -1 || this.currentUrl.indexOf("/info") > -1) {
          this.showFilter = false;
          this.isFrontend = true;
        } else if (this.currentUrl.indexOf("/newsletter") > -1  || this.currentUrl.indexOf("/certificate") > -1 || this.currentUrl.indexOf("inline_certificate") > -1) {
          this.showFilter = false;
          // localStorage.setItem("media_id", "internal");
          localStorage.setItem("media_type", "all");
        } 
        this.getClientInfo();
        this.getData();
        this.getTags();
        this.getUsedFiles();
        this.configureDropzone();
      },
      getTags(){
        axios.get("/media/alltags").then((response) => {
          this.allTags = response.data;
          this.uniqueTags();
        });
      }
    },
    mounted() {
      this.initiate();
      Bus.$on("tab-change", (data) => {
        this.loading = true;
        this.getData(false, data);
        this.showDropzone = false;
      });
      Bus.$on("filters", (data) => {
        this.files = data;
        this.searchedFiles = data;
      });
      Bus.$on("change-file", (data) => {
        this.loading = true;
        this.getTags();
        this.files = data.files;
        this.searchedFiles = data.files;
        this.loading = false;
        document.getElementById("filterFile").click();
      });
      Bus.$on("delete-file", (data) => {
        let id = data[0];
        let usedFiles = data[1];
        this.id_to_delete = id;
        this.used_info_list = usedFiles;
      });
      Bus.$on("file-moved", (payLoad) => {
        this.files = this.files.filter(obj => {
          return obj.id != payLoad;
        })
      });
      Bus.$on("files-data", (payLoad) => {
        let typeid, type;
        typeid = payLoad.id;
        type = payLoad.type;
        this.getData(typeid, type);
        this.checkDropzone(typeid, type);
        this.type = type;
        this.type_id = typeid;
      });
      Bus.$on("all-files", (response) => {
        this.files = response.files;
        this.searchedFiles = response.files;
        this.showDropzone = false;
        this.getUsedFiles();
      });

      if (this.$props.show_filter === "true") {
        this.showFilter = true;
        this.filterFrontend = false;
      }
    },
    watch: {
      allTags() {
        if (this.allTags !== undefined && this.allTags.length) {
          this.filterFrontend = true;
        }
        if (!this.isFrontend && this.displayMode != "overlay") {
          this.filterFrontend = true;
        } 
      },
    }
  };
</script>

<style scoped>
  th.sortable {
      position: relative;
      cursor: pointer;
  }
  th.sortable::after {
    font-family: FontAwesome;
    content: "";
    background-image: url("../../../../public/icons/sort-solid.svg");
    background-repeat: no-repeat;
    background-size: contain;
    position: absolute;
    top: 40%;
    width: 10px;
    height: 10px;
    right: 8px;
    color: #7c82dc;
  }
  th.sortable.asc::after {
    content: "";
    background-image: url("../../../../public/icons/sort-up-solid.svg");
  }

  th.sortable.desc::after {
    content: "";
    background-image: url("../../../../public/icons/sort-down-solid.svg");
  }

  th.sortable:hover::after {
    color: #333;
  }

  .courseDropzone {
    position: relative;
  }
  .dropzone-wrap {
    height: auto;
  }
  .fileupload-process {
    display: block;
    height: 22px;
    border-bottom: 1px dashed lightgray;
  }
  .dz-message {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .dz-processing {
    position: absolute;
    display: flex;
    flex-direction: row-reverse;
    right: 10px;
    top: 10px;
    align-items: center;
  }
  .dz-error-mark {
    display: none;
  }
  .dz-success-mark {
    display: none;
  }
  @media screen and (max-width: 650px) {
    .hide-on-small {
      display: none;
    }
    .frontend_tags {
      width: 100% !important;
    }
  }
  .frontend_tags {
    width: 70%;
  }
  .overlay_filter {
    background-color: white;
    margin-bottom: 0;
    padding: 10px;
    border-radius: 5px 5px 0 0;
    width: 100%;
  }
  .borderRadius {
    border-radius: 0 !important;
  }
  .fancybox-slide video {
      width  : 1280px;
      height : 720px;
      max-width  : 80%;
      max-height : 80%;
      margin: 0;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  .file-tr td{
    text-align: left;
  }
  #dropzone-placeholder{
    pointer-events: none;
  }
  .position-relative{
    position: relative;
  }
   .courseDropzone:hover{
    cursor:pointer;
  }
  .search-upload{
    margin-bottom:10px
  }

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/upload.vue